// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';

import { InlineTextButton } from '../Button/Button';
import MenuItem from '../MenuItem/MenuItem';
import { personaCopy } from '../../config/marketplaceContent';
import { useActivePersonaMaybe } from '../../context/ActivePersonaContext';

import css from './PersonaSwitcherMenu.module.css';

/** Returns flat MenuItem nodes — must be spread inside MenuContent (not wrapped in a component). */
export const usePersonaSwitcherMenuItems = () => {
  const personaContext = useActivePersonaMaybe();
  if (!personaContext) {
    return [];
  }

  const { activePersona, activatedPersonas, switchPersona } = personaContext;
  const switchable = activatedPersonas.filter(p => p !== activePersona);

  if (switchable.length === 0) {
    return [
      <MenuItem key="persona-hub">
        <Link to="/settings/profile" className={css.menuLink}>
          <span className={css.menuItemBorder} />
          {personaCopy.managePersonasLink}
        </Link>
      </MenuItem>,
    ];
  }

  return [
    <MenuItem key="persona-label">
      <span className={css.sectionLabel}>
        {personaCopy.activePersonaLabel}: {personaCopy.personaLabels[activePersona]}
      </span>
    </MenuItem>,
    ...switchable.map(persona => (
      <MenuItem key={`switch-${persona}`}>
        <InlineTextButton
          rootClassName={css.menuLink}
          onClick={() => switchPersona(persona)}
          data-testid={`switch-persona-${persona}`}
        >
          <span className={css.menuItemBorder} />
          {personaCopy.switchToPersona.replace('[persona]', personaCopy.personaLabels[persona])}
        </InlineTextButton>
      </MenuItem>
    )),
    <MenuItem key="persona-hub">
      <Link to="/settings/profile" className={css.menuLink}>
        <span className={css.menuItemBorder} />
        {personaCopy.managePersonasLink}
      </Link>
    </MenuItem>,
  ];
};

/** @deprecated Use usePersonaSwitcherMenuItems inside MenuContent instead. */
const PersonaSwitcherMenu = () => {
  const items = usePersonaSwitcherMenuItems();
  return <>{items}</>;
};

export default PersonaSwitcherMenu;
